import { H3 } from '@h3/types';
import { request } from '@h3/request';

/** 获取按钮列表 */
export function getActionList(
    schemaCode: string,
    mergeBizData?: boolean,
    selectable?: boolean,
    actionCodes?: string[],
) {
    const params: H3.SmartAction.Request.TGetSmartActionParams = {
        schemaCode,
        mergeBizData,
        selectable,
        actionCodes,
    };
    return request<H3.Http.Response.H3Response<H3.SmartAction.Response.TSmartActionGetListResponse>>(
        '/v1/smartaction/designer/get',
        {
            method: 'post',
            data: params,
            disableBizError: true,
            camelCase: true,
        },
    );
}

// 获取表单运行时按钮
export function getRuntimeActions(schemaCode: string, actionCodes?: string[]) {
    return request<H3.Http.Response.H3Response<H3.SmartAction.IAction[]>>('/v1/smartaction/list', {
        method: 'post',
        data: {
            schemaCode,
            actionCodes,
        },
        disableBizError: true,
        camelCase: true,
    });
}

/** 删除按钮 */
export function removeAction(schemaCode: string, actionCode: string) {
    const params: H3.SmartAction.Request.TRemoveSmartActionParams = {
        schemaCode,
        actionCode,
    };
    return request<H3.Http.Response.H3Response<boolean>>('/v1/smartaction/designer/remove', {
        method: 'post',
        data: params,
        disableBizError: true,
        camelCase: true,
    });
}

/**
 * 保存按钮
 * @param action 按钮配置
 * @returns
 */
export function saveAction(action: H3.SmartAction.IAction) {
    const params: H3.SmartAction.Request.TSaveSmartActionParams = {
        smartAction: action,
    };
    return request<H3.Http.Response.H3Response<boolean>>('/v1/smartaction/designer/save', {
        method: 'post',
        data: params,
        disableBizError: true,
        camelCase: true,
    });
}

/**
 *
 * @param params 按钮场景配置请求参数
 * @returns
 */
export function saveActionScenes(params: H3.SmartAction.Request.TSmartActionSceneSettingParams) {
    return request<H3.Http.Response.H3Response<boolean>>('/v1/smartaction/designer/locations/save', {
        method: 'post',
        data: params,
        disableBizError: true,
        camelCase: true,
    });
}

/** 保存按钮角色 */
export function saveActionRoles(schemaCode: string, actionCode: string, roleIds: string[]) {
    const params = {
        schemaCode,
        actionCode,
        roleIds,
    };
    return request<H3.Http.Response.H3Response<boolean>>('/v1/smartaction/designer/roles/save', {
        method: 'post',
        data: params,
        disableBizError: true,
        camelCase: true,
    });
}

/**
 * 加载表单按钮顺序
 * @param schemaCode
 */
export function getFormActions(schemaCode: string) {
    return request<H3.Http.Response.H3Response<string[]>>('/v1/smartaction/designer/form/smartactioncodes', {
        method: 'get',
        params: {
            schemaCode,
        },
        disableBizError: true,
    });
}

/**
 * 保存表单按钮顺序
 * @param schemaCode
 * @param actionCodes 按钮编码列表
 */
export function saveFormActions(schemaCode: string, actionCodes: string[]) {
    return request<H3.Http.Response.H3Response<boolean>>('/v1/smartaction/designer/form/smartactioncodes', {
        method: 'post',
        data: {
            schemaCode,
            actionCodes,
        },
        disableBizError: true,
    });
}

// 按钮默认执行的参数
export function executeAction(params: H3.SmartAction.Request.TActionExecuteParams) {
    return request<H3.Http.Response.H3Response<boolean>>('/v1/smartaction/execute', {
        method: 'post',
        data: params,
        disableBizError: true,
    });
}

// 验证字段一致性
export function validateFieldConsistency(schemaCode: string, properties: string[], bizObjectIds: string[]) {
    return request<H3.Http.Response.H3Response<boolean>>('/v1/bizdata/validateFieldConsistency', {
        method: 'post',
        data: {
            schemaCode,
            properties,
            bizObjectIds,
        },
        disableBizError: true,
    });
}
